<template>
  <div id="app-container">
    <DxTreeList
      id="treeList"
      :data-source="employees"
      :root-value="-1"
      key-expr="id"
      parent-id-expr="HeadID"
      :auto-expand-all="true"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      @selection-changed="selectEmployee"
      @row-inserting="onRowInserting"
      @row-updating="updating"
      @row-removing="validateRemove"
    >
      <DxColumn data-field="name" :fixed="true">
        <DxRequiredRule />
      </DxColumn>
      <DxColumn data-field="brand">
        <DxRequiredRule />
      </DxColumn>
      <DxColumn data-field="type" />
      <DxColumn data-field="model" />
      <DxColumn data-field="warranty_date" />

      <DxColumnFixing :enabled="true" />
      <DxColumnChooser :enabled="true" />
      <DxFilterRow :visible="true" />
      <DxSearchPanel :visible="true" />
      <DxSelection mode="single" />
      <DxEditing
        mode="popup"
        :allow-updating="true"
        :allow-adding="true"
        :allow-deleting="true"
      >
        <DxTexts delete-row="🗑️" edit-row="✏️" add-row="➕" />
      </DxEditing>

      <DxRowDragging
        :on-drag-change="onDragChange"
        :on-reorder="onReorder"
        :allow-drop-inside-item="true"
        :allow-reordering="true"
        :show-drag-icons="true"
      />

      <DxPaging :enabled="true" :page-size="10" />
    </DxTreeList>
    <!-- <p id="selected-employee" v-if="selectedEmployee">
      Selected employee: {{ selectedEmployee.name }}
    </p> -->
  </div>
</template>

<script>
import {
  DxTreeList,
  DxColumn,
  DxRequiredRule,
  DxColumnChooser,
  DxColumnFixing,
  DxFilterRow,
  DxSearchPanel,
  DxSelection,
  DxEditing,
  DxRowDragging,
  DxPaging,
  DxTexts,
} from "devextreme-vue/tree-list";
export default {
  components: {
    DxTreeList,
    DxColumn,
    DxRequiredRule,
    DxColumnChooser,
    DxColumnFixing,
    DxFilterRow,
    DxSearchPanel,
    DxSelection,
    DxEditing,
    DxRowDragging,
    DxPaging,
    DxTexts,
  },
  props: { location_id: Object },
  data() {
    return {
      employees: [],
      selectedEmployee: undefined,
    };
  },
  mounted() {
    this.getAssets();
  },
  methods: {
    getAssets() {
      this.$API.get("asset/get-all-asset").then((res) => {
        console.log(res.data.data, "testLogAPI");
        this.employees = res.data.data;
      });
    },

    updating(e) {
      console.log(e); //Event การอัพเดทชื่อ
      let data = {
        id: e.oldData.id,
        name: e.newData.name,
        brand: e.newData.brand,
        type: e.newData.type,
        model: e.newData.model,
        warranty_date: e.newData.warranty_date,
      };
      console.log(data);
      this.$API.post("asset/update-asset", data).then((res) => {
        if (res.status == 200)
          this.$vs.notify({
            title: "Asset Update",
            text: res.data.message,
            color: "primary",
            position: "top-center",
          });
      });
    },
    validateRemove(e) {
      console.log(e.data.id); //Event การลบชื่อ
      let body = { id: e.data.id };
      console.log(body);

      this.$API.post("asset/delete-asset", body).then((res) => {
        console.log(res);
        if (res.status == 200)
          this.$vs.notify({
            title: "Asset Delete",
            text: res.data.message,
            color: "primary",
            position: "top-center",
          });
      });
    },
    onRowInserting(e) {
      //Add MOM
      // Handler of the "rowInserting" event
      console.log(e, "P1"); //Event การเพิ่มชื่อ

      let data = {
        name: e.data.name,
        brand: e.data.brand,
        type: e.data.type,
        model: e.data.model,
        warranty_date: e.data.warranty_date,
        location_id: this.location_id,
        HeadID: e.data.HeadID,
      };
      this.$API.post("asset/create-asset", data).then((res) => {
        if (res.status == 200)
          this.$vs.notify({
            title: "Asset Create",
            text: res.data.message,
            color: "primary",
            position: "top-center",
          });
        else if (res.status != 200)
          this.$vs.notify({
            title: "Asset Create",
            text: res.data.message,
            color: "danger",
            position: "top-center",
          });
      });
    },
    selectEmployee(e) {
      e.component.byKey(e.currentSelectedRowKeys[0]).done((employee) => {
        if (employee) {
          console.log(employee, "test"); //Event การกดคลิกที่ชื่อ
          this.selectedEmployee = employee;
        }
      });
    },
    onDragChange(e) {
      let visibleRows = e.component.getVisibleRows(),
        sourceNode = e.component.getNodeByKey(e.itemData.id),
        targetNode = visibleRows[e.toIndex].node;

      while (targetNode && targetNode.data) {
        if (targetNode.data.id === sourceNode.data.id) {
          e.cancel = true;
          break;
        }
        targetNode = targetNode.parent;
      }
    },
    onReorder(e) {
      console.log(e);
      console.log("P3");
      let visibleRows = e.component.getVisibleRows(),
        sourceData = e.itemData,
        targetData = visibleRows[e.toIndex].data;
      console.log(sourceData, "Child"); // Id ของคนที่อยู่ที่ปลายเมาส์ที่โดนจับโยกไปเป็นลูกกะจ๊อกของคนอื่น อันนี้ HeadID จะอัพเดทเอง
      console.log(targetData, "Mom"); // Id ปลายทางที่ลูกกะจ๊อกจะไปอยู่ด้วย
      if (e.dropInsideItem) {
        e.itemData.HeadID = targetData.id;
        e.component.refresh();
      } else {
        let sourceIndex = this.employees.indexOf(sourceData),
          targetIndex = this.employees.indexOf(targetData);

        if (sourceData.HeadID !== targetData.HeadID) {
          sourceData.HeadID = targetData.HeadID;
          if (e.toIndex > e.fromIndex) {
            targetIndex++;
          }
        }

        this.employees.splice(sourceIndex, 1);
        this.employees.splice(targetIndex, 0, sourceData);

        this.employees = this.employees.slice();
      }
      let data = {
        id: sourceData.id,
        HeadID: sourceData.HeadID,
      };
      console.log(data, "PP");
      this.$API.post("asset/drag-and-drop-asset", data).then((res) => {
        if (res.status == 200)
          if (res.status == 200)
            this.$vs.notify({
              title: "Asset Update",
              text: res.data.message,
              color: "primary",
              position: "top-center",
            });
          else if (res.status != 200)
            this.$vs.notify({
              title: "Asset Update",
              text: res.data.message,
              color: "danger",
              position: "top-center",
            });
      });
    },
  },
};
</script>

<style>
#treeList {
  height: 100%;
}

#app-container {
  width: 100%;
  position: relative;
}

#selected-employee {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
